export default [
  [`Размеры`, `3XS`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российский размер`, `36`, `38`, `40`, `42`, `44`, `46`, `48`, `50`, `52`]
];
